import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import Input from 'components/Input/Input';
import PasswordInput from 'components/Input/PasswordInput';
import { SubdomainInput } from 'components/Input/SubdomainInput';
import { SwitchImplementationButton } from 'components/LinkButton/LinkButton';

const SignInNamelyCredential = ({
  isLoading,
  onSubmit,
  provider,
  handleClick,
}: RegisterImplementationProps) => {
  return (
    <SignInBase
      onSubmit={onSubmit}
      fieldNames={['subdomain', 'username', 'password']}
      render={({ subdomain, username, password }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <SubdomainInput
                label="Subdomain"
                value={subdomain.value}
                onChange={(event) => subdomain.onChange(event.target.value)}
                invalid={subdomain.invalid}
                domain="namely.com"
              />
              <Input
                value={username.value}
                onChange={(event) => username.onChange(event.target.value)}
                invalid={username.invalid}
                label="Email Address"
                id="username"
              />
              <PasswordInput
                reset={{
                  uri: new URL('https://namely.com/login/'),
                  providerDisplayName: provider.displayName,
                }}
                value={password.value}
                onChange={(event) => password.onChange(event.target.value)}
                invalid={password.invalid}
              />
            </MainContainer>
            {handleClick && (
              <SwitchImplementationButton onClick={handleClick} useNewDesign>
                Use an API Token instead
              </SwitchImplementationButton>
            )}
            <LoaderButton
              isLoading={isLoading}
              disabled={
                isLoading ||
                !subdomain.value ||
                !username.value ||
                !password.value
              }
              type="submit"
              text="Connect"
            />
          </>
        );
      }}
    />
  );
};

export default SignInNamelyCredential;
